<template>
    <v-layout
        row
        :style="maxWidth"
    >
        <v-flex
            class="ml-3"
            :style="maxWidth"
        >
            <breadcrumbs
                :items="breadcrumbsItems"
            ></breadcrumbs>
            <v-card
                class="ma-3 col-sm-6" outlined
            >
                <v-card-title>Create Service</v-card-title>
                <div class="col">
                    <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                    >
                        <v-text-field
                            disabled
                            label="Outlet"
                            v-model="outlet.name"
                        ></v-text-field>

                        <v-text-field
                            v-model="name"
                            :rules="nameRules"
                            label="Name *"
                            autocomplete="off"
                            required
                        ></v-text-field>

                        <v-text-field
                            v-model="description"
                            label="Description"
                            autocomplete="off"
                        ></v-text-field>

                        <v-text-field
                            v-model="interval"
                            label="Interval(minutes)"
                            autocomplete="off"
                        ></v-text-field>

                        <div class="pa-3">
                            <v-row class="pb-5">
                                <v-label class="mt-5">Operation Times</v-label>
                                <v-btn
                                    @click="timesDialog = true"
                                    x-small
                                    class="ml-2"
                                    color="success"
                                >
                                    +
                                </v-btn>
                            </v-row>
                            <v-label>Operation:</v-label>
                            <v-row class="pa-3">
                                <v-input
                                    v-for="(ot) in operationTimes"
                                    append-icon="close"
                                    :key="ot.id"
                                    background-color="#F5F5F5"
                                    @click:append="removeOperationTime(ot)"
                                >
                                    {{ convertDayName(ot.day) }} <br> {{ ot.time }}
                                </v-input>
                            </v-row>
                            <v-label>Break:</v-label>
                            <v-row class="pa-3">
                                <v-input
                                    v-for="(bt) in breakTimes"
                                    append-icon="close"
                                    :key="bt.id"
                                    background-color="#F5F5F5"
                                    @click:append="removeOperationTime(bt)"
                                >
                                    {{ convertDayName(bt.day) }} <br> {{ bt.time }}
                                </v-input>
                            </v-row>
                        </div>

                        <v-dialog
                            v-model="timesDialog"
                            width="400"
                        >
                            <v-card>
                                <v-row>
                                    <v-col>
                                        <v-card-title>Operation Time</v-card-title>
                                    </v-col>
                                    <v-col>
                                        <v-btn class="text-right float-right" text @click="timesDialog = !timesDialog">
                                            X
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-radio-group class="mt-0 pa-4" v-model="type" :mandatory="false" row>
                                    <v-radio label="Operation" value="operation" @change="changeDay('all')"></v-radio>
                                    <v-radio label="Break" value="break" @change="changeDay('break')"></v-radio>
                                </v-radio-group>
                                <v-select
                                    :items="days"
                                    :item-text="days.name"
                                    label="Day"
                                    v-model="day"
                                    multiple
                                    outlined
                                    class="mr-0 pl-4 col-11"
                                ></v-select>
                                <v-text-field
                                    v-model="time"
                                    label="Time"
                                    placeholder="e.g: 1300-1500"
                                    autocomplete="off"
                                    outlined
                                    class="mr-0 pl-4 col-11"
                                ></v-text-field>
                                <v-btn @click="addTime" class="font-weight-bold ml-4 mb-4" color="success">Save</v-btn>
                            </v-card>
                        </v-dialog>

                        <v-switch
                            v-model="active"
                            label="Active"
                        ></v-switch>

                        <v-text-field
                            v-model="prefix"
                            label="Prefix"
                            autocomple="off"
                        >
                        </v-text-field>

                        <v-text-field
                            v-model="queue_no_digit"
                            label="Queue No Digit"
                            autocomplete="off"
                            type="number"
                            max="5"
                            persistent-hint
                            hint="e.g.: set this value to 3, queue no format will be 001"
                        ></v-text-field>
                        <v-btn
                            :disabled="!valid"
                            color="success"
                            class="mr-4 font-weight-bold"
                            @click="submit"
                        >
                            Save
                        </v-btn>
                    </v-form>
                </div>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from 'axios'

export default {
    data: () => ({
        valid: true,
        name: '',
        nameRules: [
            v => !!v || 'Name is required',
        ],
        description: '',
        active: false,
        interval: null,
        limit: null,
        // counter_no: null,
        message: null,
        timesDialog: false,
        type: 'operation',
        day: null,
        time: null,
        days: [],
        breakDays: '',
        daySelection: [
            {text: 'Sunday', value: 0},
            {text: 'Monday', value: 1},
            {text: 'Tuesday', value: 2},
            {text: 'Wednesday', value: 3},
            {text: 'Thursday', value: 4},
            {text: 'Friday', value: 5},
            {text: 'Saturday', value: 6}
        ],
        breakTimes: [],
        operationTimes: [],
        breadcrumbsItems: '',
        prefix: null,
        queue_no_digit: null
    }),
    props: ['outlet'],
    computed: {
        maxWidth() {
            return {
                maxWidth: window.outerWidth + 'px'
            }
        }
    },
    methods: {
        submit() {
            const prefix = '/outlet/' + this.outlet.id;
            if (this.$refs.form.validate()) {
                axios.post(prefix + '/service', {
                    name: this.name,
                    description: this.description,
                    active: this.active,
                    interval: this.interval,
                    limit: this.limit,
                    // counter_no: this.counter_no,
                    message: this.message,
                    prefix: this.prefix,
                    queue_no_digit: this.queue_no_digit,
                }).then(response => {
                    this.operationTimes.forEach(function (ot) {
                        axios.post('/operation_times', {
                            days: ot.day,
                            time: ot.time,
                            type: ot.type,
                            model_id: response.data.id,
                            model_type: 'App\\Service'
                        })
                    });
                    this.breakTimes.forEach(function (ot) {
                        axios.post('/operation_times', {
                            days: ot.day,
                            time: ot.time,
                            type: ot.type,
                            model_id: response.data.id,
                            model: 'App\\Service'
                        })
                    });
                    window.location.href = prefix + '/services';
                });
            }
        },
        addTime() {
            let t = {
                day: this.day,
                time: this.time,
                type: this.type,
            };

            t.type === 'operation' ? this.operationTimes.push(t) : this.breakTimes.push(t);

            if (t.type === 'operation') this.breakDays += t.day;
            let bd = '';
            this.operationTimes.forEach(function (t, idx, array) {
                if (idx !== array.length - 1) {
                    bd += t.day + ','
                } else {
                    bd += t.day
                }
            });
            this.breakDays = bd;

            this.day = null;
            this.time = null;
            this.type = 'operation';
            this.timesDialog = false;
        },
        convertDayName(day) {
            let dayName = '';

            this.daySelection.forEach(function (d) {
                day.forEach(function (x) {
                    if (d.value === parseInt(x)) dayName += d.text + ','
                })
            });

            return dayName;
        },
        removeOperationTime(t) {
            // axios to remove operation time
            let type = t.type;
            const i = type === 'operation' ? this.operationTimes.indexOf(t) : this.breakTimes.indexOf(t);
            type === 'operation' ? this.operationTimes.splice(i, 1) : this.breakTimes.splice(i, 1);
        },
        changeDay(type) {
            if (type === 'all') this.days = this.daySelection;
            if (type === 'break') {
                let b = this.breakDays;
                let result = [];
                this.daySelection.forEach(function (d) {
                    if (b.includes(d.value)) result.push(d);
                });
                this.days = result;
            }
        },
    },
    beforeMount() {
        this.days = this.daySelection;
        this.breadcrumbsItems = [
            {
                disabled: false,
                href: '/',
                link: true,
                text: 'Home',
            },
            {
                disabled: false,
                href: '/outlet/' + this.outlet.id + '/edit',
                link: true,
                text: this.outlet.name,
            },
            {
                disabled: true,
                href: '#',
                link: true,
                text: 'Create Service',
            },
        ];
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Services/ServiceCreate.vue